// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {

    .DemandElement {
        width: 92%;
        box-shadow: 0px 0px 5px 2px rgba(63, 63, 63, 0.445);
        border-radius: 20px;
        padding: 40px 70px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 700;
        }


        .elements {
            margin: 20px 0px;

            .part1 {
                font-size: 14px;
                border: 1px solid #5760AD;
                font-weight: 600;
                background-color: #C4DFEB;
            }
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #A4B1C2;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: black;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

    .tableContainer {
        width: 100%;


        table {

            width: 100%;


            tr,
            th,
            td {
                padding: 10px;
            }

            th,
            td {
                /* border: 1px solid #000000 !important; */
                font-size: 14px;

            }

            thead {
                tr {
                    background-color: #2C78DB;
                    color: #FBEEF5;

                    th {
                        font-weight: 700 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */
                    border: 2px solid #4888DD !important;
                    background-color: #E0E6F4;

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/DemandManagement/DemandGeneration/DemandGenral.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,UAAU;QACV,mDAAmD;QACnD,mBAAmB;QACnB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;;YAEhB;gBACI,eAAe;gBACf,yBAAyB;gBACzB,gBAAgB;gBAChB,yBAAyB;YAC7B;QACJ;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,WAAW;;;QAGX;;YAEI,WAAW;;;YAGX;;;gBAGI,aAAa;YACjB;;YAEA;;gBAEI,0CAA0C;gBAC1C,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,cAAc;;oBAEd;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;oBAC1C,oCAAoC;oBACpC,yBAAyB;;oBAEzB;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;AACJ","sourcesContent":[".budgetContainer {\n\n    .DemandElement {\n        width: 92%;\n        box-shadow: 0px 0px 5px 2px rgba(63, 63, 63, 0.445);\n        border-radius: 20px;\n        padding: 40px 70px;\n        background-color: white;\n\n        label {\n            font-size: 16px;\n            font-weight: 700;\n        }\n\n\n        .elements {\n            margin: 20px 0px;\n\n            .part1 {\n                font-size: 14px;\n                border: 1px solid #5760AD;\n                font-weight: 600;\n                background-color: #C4DFEB;\n            }\n        }\n\n\n        textarea,\n        select,\n        input {\n            width: 100%;\n            border: 1px solid #A4B1C2;\n            padding: 5px 10px;\n            font-size: 16px;\n            font-weight: 400;\n            border-radius: 3px;\n        }\n\n        select {\n            font-size: 14px !important;\n            font-weight: 500 !important;\n            color: black;\n        }\n\n        select:focus {\n            color: black;\n        }\n\n        textarea {\n            height: 12vh;\n        }\n\n        ::placeholder {\n            color: #817f7f;\n        }\n    }\n\n    .tableContainer {\n        width: 100%;\n\n\n        table {\n\n            width: 100%;\n\n\n            tr,\n            th,\n            td {\n                padding: 10px;\n            }\n\n            th,\n            td {\n                /* border: 1px solid #000000 !important; */\n                font-size: 14px;\n\n            }\n\n            thead {\n                tr {\n                    background-color: #2C78DB;\n                    color: #FBEEF5;\n\n                    th {\n                        font-weight: 700 !important;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    /* border: 1px solid #000000 !important; */\n                    border: 2px solid #4888DD !important;\n                    background-color: #E0E6F4;\n\n                    td {\n                        /* border: 1px solid #000000 !important; */\n                        font-weight: 400 !important;\n                    }\n\n                }\n            }\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
